export { QuoteSection } from './QuoteSection';
